import { render } from "./Handset.vue?vue&type=template&id=ebb74516"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Handset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebb74516"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebb74516', __exports__)) {
    api.reload('ebb74516', __exports__)
  }
  
  module.hot.accept("./Handset.vue?vue&type=template&id=ebb74516", () => {
    api.rerender('ebb74516', render)
  })

}


export default __exports__